/* =============================================================
   AADHAV ACADEMY – ADMIN FEES SELECTORS
============================================================= */

export const selectFeesState = (state) =>
  state.admin?.fees || {};

export const selectFees = (state) =>
  selectFeesState(state).fees || [];

export const selectPaidFees = (state) =>
  selectFeesState(state).paidFees || [];

export const selectFeesLoading = (state) =>
  selectFeesState(state).loading || false;

export const selectFeesError = (state) =>
  selectFeesState(state).error || null;

export const selectFeesCurrentPage = (state) =>
  selectFeesState(state).currentPage || 1;

export const selectFeesTotalPages = (state) =>
  selectFeesState(state).totalPages || 1;

export const selectSelectedFee = (state) =>
  selectFeesState(state).selectedFee || null;

/* ================= LAST PAID FEE ================= */

export const selectLastPaidFee = (state) =>
  selectFeesState(state).lastPaidFee || null;

/* ================= PAID FEES PAGINATION ================= */

export const selectPaidFeesCurrentPage = (state) =>
  selectFeesState(state).paidFeesCurrentPage || 1;

export const selectPaidFeesTotalPages = (state) =>
  selectFeesState(state).paidFeesTotalPages || 1;

export const selectPaidFeesTotalRecords = (state) =>
  selectFeesState(state).paidFeesTotalRecords || 0;

export const selectPaidFeesSearch = (state) =>
  selectFeesState(state).paidFeesSearch || "";